import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/http.service';
import { ImagePopupComponent } from 'src/app/support/image-popup/image-popup.component';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss']
})
export class DepositComponent {

  public is_loading:boolean = false;
  public deposits:any = [];
  public banks:any = [];
  public status:number = 2;
  public company_uuid:string;
  constructor(private http:HttpService, private ngbModal:NgbModal) { 
    this.company_uuid = this.http.getStaticSelectedCompany();
    this.getDeposits();
    this.getBanks();
  }

  public async getBanks() {
    let rtn:any = await this.http.post("/admin/bank/get", {usage: 'deposit'});
    this.banks = rtn.banks;
  }

  public async getDeposits(status:number = 2):Promise<void> {
    this.is_loading = true;
    this.status = status;
    let rtn:any = await this.http.post("/admin/deposit/get", {status: this.status});
    this.deposits = rtn;
    this.is_loading = false;
  }

  async updateDeposit(deposit:any) {

    let check:any = await this.http.post("/admin/promotion/validate-deposit", {player_uuid: deposit.player_uuid});
    if(!check.status) {
      this.http.toast("There are active promotions and existing balance will be forfited. You are required to cancel the promotion first.", "error");
      return;
    }

    let rtn:any = await this.http.post("/admin/deposit/update", deposit);

    if(rtn.status){ 
      this.getDeposits();
    }

    if(rtn.message){
      this.http.toast(rtn.message, "error");
    }
  }

  openImagePopup(file:string) {
    let y = this.ngbModal.open(ImagePopupComponent, {
      size: 'lg',
      centered: true
    });

    y.componentInstance.image = file;
  }
}
